module.exports = __webpack_public_path__ + "static/img/8.7613b6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/8.jpg
// module id = HU4R
// module chunks = 16